<template>

  <div class="ob-content">
    <ob-filters>
      <assets-filters @change="$refs.table.refresh()"></assets-filters>

      <template v-slot:actions>
        <v-list-item @click="add()" v-if="$can('admin')">
          <v-list-item-title>
            <font-awesome-icon icon="plus-circle"></font-awesome-icon>
            {{ $t('assets.new') }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="$router.push({name: 'entity/export-import', params: {entity: 'asset'}})">
          <v-list-item-title>
            <font-awesome-icon icon="exchange-alt"></font-awesome-icon>
            {{ $t('export-import') }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="manageVariables()" v-if="$can('admin')">
          <v-list-item-title>
            {<font-awesome-icon icon="times" transform="shrink-5"></font-awesome-icon>}
            {{ $t('assets.assign-variables') }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </ob-filters>

    <v-card>
      <assets-table
        ref="table"
        :source="source"
        :state="table"
        @change="saveTable($event)"
        @click="$router.push({ name: 'assets/id', params: { id: $event.id} })"
      />
    </v-card>

    <v-btn fab fixed bottom right color="primary" @click="add()">
      <v-icon>add</v-icon>
    </v-btn>
  </div>

</template>

<script>

import {mapMutations, mapState} from 'vuex'
import AssetsTable from './components/assets-table'
import AssetsFilters from './components/assets-filters'
import AssetManager from './components/asset-manager'
import CreateAssetDialog from './components/create-asset-dialog'
import ApiService from '../../services/api.service.es6'
import ObFilters from '../shared/components/filters'

export default {
  name: 'assets',

  data () {
    return {
      source: args => ApiService.findAllPaginated('assets', this.apiFilters, args.sort, args.pagination)
    }
  },

  computed: {
    ...mapState('filters/assets', [
      'filters',
      'table'
    ]),

    apiFilters() {
      return {
        filter: [
          {name: 'assets.name', value: this.filters.search ? `*${this.filters.search}*` : null},
          {name: 'assets.assetTypeId', value: this.filters.assetTypes},
          {name: 'assets.deviceType', value: this.filters.deviceTypes},
        ]
      }
    }
  },

  methods: {
    ...mapMutations('filters/assets', [
      'saveTable'
    ]),

    async add () {
      const asset = await this.$dialog.showAndWait(CreateAssetDialog)

      if (asset) {
        const response = await this.$store.dispatch('updateItem', {modelName: 'assets', item: asset})
        this.$router.push({ name: 'assets/id', params: { id: response.id } })
      }
    },

    async manageVariables () {
      await this.$dialog.showAndWait(AssetManager, { width: 800 })
    }
  },

  components: {
    ObFilters,
    AssetsFilters,
    AssetsTable
  },
}
</script>

<style scoped lang="scss">

</style>
